export default "__VITE_ASSET__ZwlTTgs___"